import React from "react";
import Link from "gatsby-link";
import resolveLink from "src/utils/resolveLink";

const SplitDropdownItem = (props) => {
  return (
    <Link
      to={resolveLink(`/${props.target.cached_url}`)}
      className="hover:!text-brightgreen font-display mr-4 block py-1 text-sm duration-300"
    >
      {props.name}
    </Link>
  );
};

export default SplitDropdownItem;
